/**
 * @generated SignedSource<<13bd5269faed88f24423ce7230ed0964>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type AssignableDropdownQuickDateSelectFirstFutureEventQuery$variables = {
  streamId: string;
};
export type AssignableDropdownQuickDateSelectFirstFutureEventQuery$data = {
  readonly noteStream: {
    readonly firstFutureEvent: {
      readonly start: string | null;
    } | null;
  } | null;
};
export type AssignableDropdownQuickDateSelectFirstFutureEventQuery = {
  response: AssignableDropdownQuickDateSelectFirstFutureEventQuery$data;
  variables: AssignableDropdownQuickDateSelectFirstFutureEventQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "streamId"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "streamId"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "start",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "AssignableDropdownQuickDateSelectFirstFutureEventQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "NoteStream",
        "kind": "LinkedField",
        "name": "noteStream",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Event",
            "kind": "LinkedField",
            "name": "firstFutureEvent",
            "plural": false,
            "selections": [
              (v2/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "AssignableDropdownQuickDateSelectFirstFutureEventQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "NoteStream",
        "kind": "LinkedField",
        "name": "noteStream",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Event",
            "kind": "LinkedField",
            "name": "firstFutureEvent",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              (v3/*: any*/)
            ],
            "storageKey": null
          },
          (v3/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "df520d90e2ff826c1f9d9f7ccffbf757",
    "id": null,
    "metadata": {},
    "name": "AssignableDropdownQuickDateSelectFirstFutureEventQuery",
    "operationKind": "query",
    "text": "query AssignableDropdownQuickDateSelectFirstFutureEventQuery(\n  $streamId: ID!\n) {\n  noteStream(id: $streamId) {\n    firstFutureEvent {\n      start\n      id\n    }\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "d3b0467be96109193fa563fc7f2c7c7d";

export default node;
